import { useRef, useCallback } from 'react'

export const OPEN_PROVIDER_EVENT = 'veridia:open-provider-mode'

/**
 * Dispatches a global event to open Provider Mode from anywhere in the application.
 */
export function triggerProviderMode() {
  window.dispatchEvent(new CustomEvent(OPEN_PROVIDER_EVENT))
}

/**
 * Hook that returns an onClick / onTap handler.
 * When tapped `tapsRequired` times within `timeoutMs`, it triggers Provider Mode.
 */
export function useProviderTapTrigger(tapsRequired = 7, timeoutMs = 2000) {
  const tapCount = useRef(0)
  const tapTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleTap = useCallback(() => {
    tapCount.current += 1
    if (tapTimer.current) {
      clearTimeout(tapTimer.current)
    }

    if (tapCount.current >= tapsRequired) {
      tapCount.current = 0
      triggerProviderMode()
      return
    }

    tapTimer.current = setTimeout(() => {
      tapCount.current = 0
    }, timeoutMs)
  }, [tapsRequired, timeoutMs])

  return handleTap
}
